webpackJsonp([164155623112449],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerImage = __webpack_require__(44);
	
	var _headerImage2 = _interopRequireDefault(_headerImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'flex' } },
	    _react2.default.createElement(_headerImage2.default, null),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '1.45rem 1.0875rem'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        { style: { margin: 0 }, className: 'site-title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              /* color: '#605980',*/
	              color: 'red',
	              fontFamily: 'sans-serif',
	              textDecoration: 'none'
	            }
	          },
	          siteTitle
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _helloworld = __webpack_require__(25);
	
	var _helloworld2 = _interopRequireDefault(_helloworld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageWrapperStyle = {
	  display: 'inline-block'
	};
	
	var containerStyle = {
	  margin: '0%',
	  display: 'inline-block'
	};
	
	var headerImgStyle = {
	  borderRadius: '50%',
	  position: 'inline',
	  width: '150px',
	  marginTop: '11px',
	  filter: 'saturate(50%)'
	};
	
	var circleStyle = {
	  position: 'relative',
	  width: '100%',
	  margin: '0 auto'
	};
	
	var circleTextStyle = {
	  fontFamily: 'Courier, monospaced',
	  fontSize: '16px',
	  fill: '#605980'
	};
	
	var circleSvgStyle = {
	  position: 'absolute',
	  left: '0',
	  top: '0',
	  width: '100%',
	  overflow: 'visible'
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "imageWrapper" },
	    _react2.default.createElement(
	      "div",
	      { id: "header-image-container", style: containerStyle },
	      _react2.default.createElement(
	        "div",
	        { id: "circle", style: circleStyle },
	        _react2.default.createElement(
	          "svg",
	          { style: circleSvgStyle,
	            className: "lead-circle-svg",
	            version: "1.1",
	            xmlns: "http://www.w3.org/2000/svg",
	            xmlnsXlink: "http://www.w3.org/1999/xlink",
	            x: "0px", y: "0px", width: "170px", height: "170px", viewBox: "0 0 320 320", "enable-background": "new 0 0 300 300", xmlSpace: "preserve" },
	          _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "circlePath", d: " M 160, 160 m -160, 0 a 160,160 0 0,1 320,0 a 160,160 0 0,1 -320,0 " })
	          ),
	          _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("use", { xlinkHref: "#circlePath", fill: "rgba(50, 50, 50, 0.0)" }),
	            _react2.default.createElement(
	              "text",
	              { style: circleTextStyle },
	              _react2.default.createElement(
	                "textPath",
	                { xlinkHref: "#circlePath" },
	                "\"Your friend online\""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/about" },
	          _react2.default.createElement("img", { id: "center-img",
	            className: "lead-circle-img",
	            src: _helloworld2.default,
	            style: headerImgStyle,
	            alt: "Shane Cummerford"
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(43);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _topLinks = __webpack_require__(79);
	
	var _topLinks2 = _interopRequireDefault(_topLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SiteNavigation = function (_React$Component) {
	    _inherits(SiteNavigation, _React$Component);
	
	    function SiteNavigation(props) {
	        _classCallCheck(this, SiteNavigation);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { degrees: 0 };
	        return _this;
	    }
	
	    SiteNavigation.prototype.rotate = function rotate() {
	        var original_degrees = this.state.degrees;
	        this.setState({ degrees: original_degrees + 6 });
	    };
	
	    SiteNavigation.prototype.resetScreen = function resetScreen() {
	        this.setState({ degrees: 0 });
	    };
	
	    SiteNavigation.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'content',
	                style: {
	                    transform: 'rotate(' + this.state.degrees + 'deg)',
	                    marginTop: this.state.degrees % 180 + 'px',
	                    position: 'relative',
	                    zIndex: '8'
	                } },
	            _react2.default.createElement(_header2.default, { siteTitle: 'Shane Cummerford' }),
	            _react2.default.createElement(_topLinks2.default, { rotateScreen: this.rotate.bind(this),
	                resetScreen: this.resetScreen.bind(this),
	                degrees: this.state.degrees
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                this.props.children
	            )
	        );
	    };
	
	    return SiteNavigation;
	}(_react2.default.Component);
	
	exports.default = SiteNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var liStyle = {
	    // display: 'inline',
	    marginBottom: '1em'
	};
	
	var rotateLiStyle = {
	    display: 'inline',
	    marginBottom: '1em'
	};
	
	var linkStyle = {
	    color: 'red',
	    fontFamily: 'Courier, monospaced',
	    border: '1px solid red',
	    padding: '3px',
	    marginRight: '2rem',
	    cursor: 'pointer'
	};
	
	var TopLinks = function TopLinks(_ref) {
	    var rotateScreen = _ref.rotateScreen,
	        resetScreen = _ref.resetScreen,
	        degrees = _ref.degrees;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'main-menu',
	            style: {
	                margin: '0 auto',
	                maxWidth: 960,
	                // padding: '1.45rem 1.0875rem',
	                float: 'left'
	            } },
	        _react2.default.createElement(
	            'ul',
	            { style: { listStyleType: 'none', textAlign: 'left' } },
	            _react2.default.createElement(
	                'li',
	                { style: liStyle },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/bio', style: linkStyle },
	                    'bio'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: liStyle },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '', style: linkStyle },
	                    '????'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: rotateLiStyle },
	                _react2.default.createElement(
	                    'span',
	                    { style: linkStyle, onClick: rotateScreen },
	                    'rotate 6\xB0 clockwise'
	                )
	            ),
	            _react2.default.createElement(
	                'li',
	                { style: rotateLiStyle },
	                _react2.default.createElement(
	                    'span',
	                    { style: {
	                            color: '#5f9cd2',
	                            fontFamily: 'Courier, monospaced',
	                            border: '1px solid #5f9cd2',
	                            padding: '3px',
	                            marginLeft: '-1rem',
	                            cursor: 'pointer',
	                            display: degrees == 0 ? 'none' : 'initial'
	                        },
	                        onClick: resetScreen },
	                    '\u21BA'
	                )
	            )
	        )
	    );
	};
	
	exports.default = TopLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/helloworld.cbde7c81.jpg";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pkc.07a5b591.gif";

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _siteNavigation = __webpack_require__(78);
	
	var _siteNavigation2 = _interopRequireDefault(_siteNavigation);
	
	var _pkc = __webpack_require__(129);
	
	var _pkc2 = _interopRequireDefault(_pkc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _siteNavigation2.default,
	        null,
	        _react2.default.createElement('img', { src: _pkc2.default, style: { outline: '2px solid white', outlineOffset: '-2px' } })
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-bio-js-0862b9c854f219801522.js